import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    FolderSortFieldE,
    SortDirectionT
} from '../../../publication-save-in-folder-dialog/publication-save-in-folder-dialog.component';

@Component({
    selector: 'app-project-selector-filter',
    templateUrl: './project-selector-filter.component.html',
    styleUrls: ['./project-selector-filter.component.scss']
})
export class ProjectSelectorFilterComponent {
    readonly FolderSortFieldE = FolderSortFieldE;

    @Input() searchText = '';
    @Input() sortField: FolderSortFieldE = FolderSortFieldE.NAME;
    @Input() sortDirection: SortDirectionT = 'asc';
    @Input() creatingItem = false;
    // Whether the picker is currently browsing a project's folders, rather than the project list itself -
    // only changes the search placeholder and the "new item" button's label/icon.
    @Input() folderLevel = false;
    // Hides the "new item" button entirely - eg. for a folder list with no owning project to create into
    // (a shared folder list), where creation isn't a valid action.
    @Input() showCreateButton = true;

    @Output() searchTextChange = new EventEmitter<string>();
    @Output() sortFieldChange = new EventEmitter<FolderSortFieldE>();
    @Output() toggleSortDirection = new EventEmitter<void>();
    @Output() startCreatingItem = new EventEmitter<void>();

    onSearchTextChange(searchText: string): void {
        this.searchTextChange.emit(searchText);
    }

    onSortFieldChange(sortField: FolderSortFieldE): void {
        this.sortFieldChange.emit(sortField);
    }

    onToggleSortDirection(): void {
        this.toggleSortDirection.emit();
    }

    onStartCreatingItem(): void {
        this.startCreatingItem.emit();
    }
}
